// A MIME type as the visitor reads it: "image/svg+xml" becomes "SVG".
export const formatLabel = (type: string) =>
  type.replace("image/", "").replace("svg+xml", "svg").toUpperCase()
